import _typeof from "@babel/runtime/helpers/typeof";
import { ApiError } from './utils/data';
export var CONVERSATION_CHANNEL_NOT_FOUND_ERROR = 'CONVERSATION_CHANNEL_NOT_FOUND';

// ************************************************************************************************
// Response data & metadata
// Sent by POST:/chat endpoint
// ************************************************************************************************
// ************************************************************************************************
//  Streaming Messages
// Sent by POST:/chat/stream endpoint
// ************************************************************************************************
// ************************************************************************************************
// Other types
// ************************************************************************************************
// All responses should be converted into StreamResponse
// - AssistantMessage -> StreamResponse
// - AgentResponse -> StreamResponse
/**
 * Interface for the Assistance Service.
 */
// ************************************************************************************************
// Type Guards
// ************************************************************************************************
export var isChatMessage = function isChatMessage(message) {
  return isHumanMessage(message) || isAssistantMessage(message) || isStreamResponse(message);
};
export var isHumanMessage = function isHumanMessage(message) {
  return message instanceof Object && message.role === 'HUMAN';
};
export var isAssistantMessage = function isAssistantMessage(message) {
  return message instanceof Object && message.role === 'ASSISTANT';
};
export var isAgentResponse = function isAgentResponse(message) {
  return message instanceof Object && isAssistantMessage(message.message);
};
export var isStreamResponse = function isStreamResponse(message) {
  return message instanceof Object && message.type === 'FINAL_RESPONSE';
};
export var isStreamError = function isStreamError(message) {
  return message instanceof Object && message.type === 'ERROR';
};
export var isStreamAnswerPart = function isStreamAnswerPart(message) {
  return message instanceof Object && message.type === 'ANSWER_PART';
};
export var isStreamTrace = function isStreamTrace(message) {
  return message instanceof Object && message.type === 'TRACE';
};
export var isStreamPluginInvocation = function isStreamPluginInvocation(message) {
  return message instanceof Object && message.type === 'PLUGIN_INVOCATION';
};
export var isPluginInvocationMessage = function isPluginInvocationMessage(message) {
  return message instanceof Object && message.role === 'PLUGIN_INVOCATION';
};
export var isFollowUpMessage = function isFollowUpMessage(message) {
  return _typeof(message) === 'object' && message !== null && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
};
export var isUHTraceContentSearch = function isUHTraceContentSearch(message) {
  return message.type === 'TRACE' && message.message.message_template === 'CONTENT_SEARCH';
};
export var isUHTraceAnalyzingState = function isUHTraceAnalyzingState(message) {
  return message.type === 'TRACE' && message.message.message_template === 'ANALYSING_STATE';
};
var isApiError = function isApiError(error) {
  return error instanceof ApiError;
};
export var isChannelNotFoundError = function isChannelNotFoundError(error) {
  var _error$metadata;
  return isApiError(error) && ((_error$metadata = error.metadata) === null || _error$metadata === void 0 ? void 0 : _error$metadata.errorCode) === CONVERSATION_CHANNEL_NOT_FOUND_ERROR;
};